import { config } from '@/config'

const GENERIC_CARRIER_LOGO = config.genericCarrierLogo
const CARRIER_LOGO_CDN_BASE = config.cdn
const EXTERNAL_CARRIER_LOGO_HOST_PATTERN = /drive\.google\.com|professional\.works/
const SUPPORTED_CARRIER_LOGO_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  'gif',
]

export function resolveCarrierLogo(logoUrl?: string | null): string {
  if (!logoUrl) {
    return `${CARRIER_LOGO_CDN_BASE}/${GENERIC_CARRIER_LOGO}`
  }

  if (EXTERNAL_CARRIER_LOGO_HOST_PATTERN.test(logoUrl)) {
    return logoUrl
  }

  const normalizedLogoUrl = logoUrl.toLowerCase()
  const hasSupportedExtension = SUPPORTED_CARRIER_LOGO_EXTENSIONS.some((ext) =>
    normalizedLogoUrl.endsWith(ext),
  )

  if (!hasSupportedExtension) {
    return `${CARRIER_LOGO_CDN_BASE}/${GENERIC_CARRIER_LOGO}`
  }

  return `${CARRIER_LOGO_CDN_BASE}/${logoUrl}`
}
